export const accountDateOfBirthFormatter = (value: string) => {
  const isDateValid = (date: Date) => date instanceof Date && !isNaN(+date);

  if (value) {
    // Assume the date is in correct format
    let date = new Date(value);

    if (!isDateValid(date)) {
      // Assume the date is in "19980722"
      date = new Date(`${value.slice(4, 6)}.${value.slice(6, 8)}.${value.slice(0, 4)}`);

      if (!isDateValid(date)) {
        // Assume the date is in "18.01.2001"
        const [day, month, year] = value.split('.');

        date = new Date(`${month}.${day}.${year}`);

        // Assume the date is in "2001.01.18", for FF
        if (!isDateValid(date)) {
          date = new Date(`${value.slice(5, 7)}/${value.slice(8)}/${value.slice(0, 4)}`);
        }
      }
    }

    return date.toLocaleString(
      navigator.language,
      { year: 'numeric', month: '2-digit', day: '2-digit' },
    );
  } else {
    return '';
  }
};
